<template>
  <div>
    <h1>CanEd</h1>
    <p>Home page</p>
    <router-link to="/auth">Sign in</router-link>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Home.vue